__turbopack_context__.v({
  "heading": "AudurWelcomeContent-module-scss-module__tp0IYG__heading",
});
